import SwiperNavigation from "@components/ProductSwiper";
import styles from "./styles.module.scss";

export const AspectInsight = ({
  activeIndex,
  setActiveIndex,
  currentAspectData,
  AspectsReviews,
}) => {
  const handleNext = () => {
    setActiveIndex((prevIndex) =>
      prevIndex < AspectsReviews.length - 1 ? prevIndex + 1 : 0,
    );
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : AspectsReviews.length - 1,
    );
  };

  const currentReview = AspectsReviews?.find(
    (_review, index) => index === activeIndex,
  );

  return (
    <div className={styles.box}>
      <SwiperNavigation
        headerText={currentAspectData?.aspect ?? ""}
        onNext={handleNext}
        onPrev={handlePrev}
        showText={true}
        improvementValue={currentReview?.score.toFixed(1) ?? "0.0"}
        currentReview={currentReview}
      />
    </div>
  );
};
